export default __webpack_public_path__ + "static/media/Rede_Seculo_21.a8ff420e.png";